import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import ProvisionalTaxReportsVM from './ProvisionalTaxReportsVM';
import { observer } from 'mobx-react';
import CollapsibleCard from '../../../App/Components/CollapsibleCard';
import { TextConstants } from '../../../Common/TextConstants';
import { Validation } from '@singularsystems/neo-core';
import Loading from '../../../App/Components/Loading/Loading';
import TaxSummary from '../Components/TaxSummary';
import RealisedGainsSummary from '../Components/RealisedGainsSummary';
import DividendTransactions from '../Components/DividendTransactions';
import DividendWithholdingTax from '../Components/DividendWithholdingTax';
import InterestTransactions from '../Components/InterestTransactions';
import InterestWithholdingTax from '../Components/InterestWithholdingTax';
import moment from 'moment';
import UnrealisedGainsSummary from '../Components/UnrealisedGainsSummary';

class ProvisionalTaxReportsParams {    
}

@observer
export default class ProvisionalTaxReportsView extends Views.ViewBase<ProvisionalTaxReportsVM, ProvisionalTaxReportsParams> {
   public static params = new ProvisionalTaxReportsParams();

    constructor(props: unknown) {
        super("Provisional Tax Reports", ProvisionalTaxReportsVM, props);
    }

    public render() {
        return (
            <div>
              {(this.viewModel.taskRunner.isBusy) && <Loading />}
              <CollapsibleCard title={TextConstants.Titles.TaxSummary} isExpanded={true}>
                <Neo.Form
                    model={this.viewModel.provisionalTaxReportsLookupCriteria}
                    onSubmit={() => this.taskRunner.waitFor(this.viewModel.search())}
                    validationDisplayMode={Validation.DisplayMode.AfterBlur}>
                    <Neo.GridLayout md={4}>
                      <Neo.FormGroup label={TextConstants.Labels.Broker}
                           bindContext={this.viewModel.provisionalTaxReportsLookupCriteria.meta.serviceProviderGroupingName}>
                           <Neo.AutoCompleteDropDown
                               itemSource={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                               bind={this.viewModel.provisionalTaxReportsLookupCriteria.meta.staticServiceProviderFileGroupingID}
                               bindDisplay={this.viewModel.provisionalTaxReportsLookupCriteria.meta.serviceProviderGroupingName}
                               displayMember={"serviceProviderGroupingName"}
                               items={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                               .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                           />
                       </Neo.FormGroup>
                       <Neo.FormGroup label={TextConstants.Labels.ClientNumber}
                         bindContext={this.viewModel.provisionalTaxReportsLookupCriteria.meta.clientNumber}>
                         <Neo.AutoCompleteDropDown
                                    minCharacters={3}
                                    delayMs={1500}     
                                    bind={this.viewModel.provisionalTaxReportsLookupCriteria.meta.clientNumber}
                                    bindDisplay={this.viewModel.provisionalTaxReportsLookupCriteria.meta.clientNumber}
                                    displayMember={"clientDescription"}
                                    items={this.viewModel.filteredClientAccounts}
                                    itemSource={async (searchText) => this.viewModel.clientAccounts.filter(clientAccount => clientAccount.clientDescription.toLowerCase().includes(searchText.toLowerCase()))}
                                />
                         </Neo.FormGroup>
                         <Neo.FormGroup
                                label={TextConstants.Labels.Account}
                                bind={this.viewModel.provisionalTaxReportsLookupCriteria.meta.rawAccountID} />
                          <Neo.FormGroup
                                        label={TextConstants.Labels.FinancialYear}
                                        bind={this.viewModel.provisionalTaxReportsLookupCriteria.meta.finYearDate}
                                        dateProps={{ maxDate: moment().toDate(), formatString: "yyyy" }}
                                    /> 
                    </Neo.GridLayout>
                    <div className="row">                            
                            <div className="col float-right">                                                          
                                <Neo.Button
                                    isSubmit
                                    variant="primary" className="form-btn float-right col-md-2"
                                >{TextConstants.Buttons.Search}</Neo.Button>
                            </div>
                    </div>
                  </Neo.Form>
                  <br />
                 {this.viewModel.showTabs && 
                   <Neo.Card title={""} className='m-1'>
                   
                     <Neo.GridLayout md={1}>
                       <Neo.Button 
                                    onClick={() => this.viewModel.downloadProvisionalTaxReport()}
                                    disabled={this.viewModel.taxSummaryVM.taxSummaryPageManager.totalRecords < 0}                              
                                    variant="primary" className="form-btn col-md-2 float-right mt-0 mb-0"
                                    size='lg'
                                >{TextConstants.Buttons.DownloadCSV}</Neo.Button>
                    <Neo.TabContainer variant='flat'>
                    
                    <Neo.Tab header={TextConstants.Titles.TaxSummary}>
                         <TaxSummary                         
                          viewModel={this.viewModel.taxSummaryVM} /> 
                      </Neo.Tab>
                    <Neo.Tab header={TextConstants.Titles.RealisedGainsSummary}>
                        <RealisedGainsSummary viewModel={this.viewModel.realisedGainsSummaryVM} />
                      </Neo.Tab>
                      <Neo.Tab header={TextConstants.Titles.UnrealisedGainsSummary}>
                        <UnrealisedGainsSummary viewModel={this.viewModel.unrealisedGainsSummaryVM} />
                      </Neo.Tab>
                      <Neo.Tab header={TextConstants.Titles.DividendTransactions}>
                        <DividendTransactions viewModel={this.viewModel.dividendTransactionsVM} />
                      </Neo.Tab>
                      <Neo.Tab header={TextConstants.Titles.DividendWitholdingTaxTranscations}>
                        <DividendWithholdingTax viewModel={this.viewModel.dividendWithholdingTaxVM} />
                      </Neo.Tab>
                      <Neo.Tab header={TextConstants.Titles.InterestTransactions}>  
                        <InterestTransactions viewModel={this.viewModel.interestTransactionsVM} />                      
                      </Neo.Tab>
                      <Neo.Tab header={TextConstants.Titles.InterestWithholdingTransactions}>     
                        <InterestWithholdingTax viewModel={this.viewModel.interestTransactionsWithholdingTaxVM} />          
                      </Neo.Tab>
                      </Neo.TabContainer>                     
                               
                    
                    </Neo.GridLayout>                    
                   </Neo.Card>
              }
              </CollapsibleCard>
                    <Neo.Modal
                        title={"Data Validation"}
                        className={'custom-modal'}
                        size="lg"
                        closeButton={false}
                        showCancelButton={false}
                        bind={this.viewModel.meta.showDataValidationModal}
                        show={this.viewModel.showDataValidationModal}
                        acceptButton = {{text: TextConstants.Buttons.Close, variant:"success"}}
                        >                                    
                        <div>                                             
                          <ul className="list-group list-group-flush card-text">
                              {this.viewModel.validationMessageList.map((message, index) => (
                                <li className="list-group-item" key={index}>{message.trim()}</li>
                              ))}                          
                          </ul>
                        </div>
                    </Neo.Modal>
            </div>
        );
    }
}